import React from "react";

export default function Star() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path stroke="#DDE0E4" strokeWidth={5} d="M3.126 3.001h27v27h-27z" />
      <path
        fill="#000"
        d="M16 10.67a.757.757 0 0 1 1.25 0L19 13.3c.101.15.257.26.437.305l3.133.794c.524.133.73.743.387 1.147l-2.052 2.42a.7.7 0 0 0-.166.494l.185 3.121c.031.521-.507.899-1.01.709l-3.02-1.135a.768.768 0 0 0-.539 0l-3.018 1.135c-.504.19-1.042-.188-1.011-.709l.185-3.12a.7.7 0 0 0-.166-.496l-2.052-2.419c-.342-.404-.137-1.014.387-1.147l3.133-.794a.742.742 0 0 0 .436-.306L16 10.67Z"
      />
    </svg>
  );
}
